import isUndefined from "lodash/isUndefined";
export default function InnerMenuItem(props) {
    if (props.allMenuItem && isUndefined(props.value))
        return props.allMenuItemText;
    if (!isUndefined(props.value))
        return props.textSelector(props.value);
    return undefined;
}
